export default __webpack_public_path__ + "static/media/BullRedLogo.0aa0dee8.svg";